import { z } from 'zod';
import { UUIDValidationSchema } from './uuid';
export const ReadStatusValidationSchema = z.object({
    userId: UUIDValidationSchema,
    lastSeen: z.date()
});
//# sourceMappingURL=readStatus.js.map